export default __webpack_public_path__ + "static/richmond-and-latitude-logo-4d0f05c09667604f529b4ab72703f7c3.jpg";